import { AuthenticationService } from './../../services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-password-reminder',
  templateUrl: './password-reminder.page.html',
  styleUrls: ['./password-reminder.page.scss'],
})
export class PasswordReminderPage implements OnInit {
  public recoveryForm: FormGroup;

  constructor(
    protected authService: AuthenticationService,
    protected router: Router,
    protected formBuilder: FormBuilder,
    protected toastController: ToastController
  ) {
    this.recoveryForm = formBuilder.group({
      email: [null, Validators.required],
    });
  }

  ngOnInit() {}

  async recover() {
    if (this.recoveryForm.invalid) {
      const toast = await this.toastController.create({
        message: 'Invalid form',
        duration: 3000,
        position: 'top',
      });
      return await toast.present();
    }

    const recoverValue = { slug: 'akpr', ...this.recoveryForm.value };
    this.authService.requestPasswordRecovery(recoverValue).subscribe(
      async (response: any) => {
        const toast = await this.toastController.create({
          message: response.message,
          duration: 3000,
          position: 'top',
        });
        await toast.present();
        if (response.success) {
          this.router.navigate([`/auth/login`]);
        }
      },
      async (errorResponse: string) => {
        const toast = await this.toastController.create({
          message:
            errorResponse ||
            'Cannot reset password. Please contact Administrator',
          duration: 3000,
          position: 'top',
        });
        return await toast.present();
      }
    );
  }
}
